import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  statusContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  status: {
    marginRight: theme.spacing(1)
  },
  rootText: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(3),
      width: '100%',
      height: theme.spacing(16),
    },
  },
  text: {
    padding: theme.spacing(5),
    textAlign: 'center'
  }
}));

export {useStyles}

